import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants, currencyString } from "@qgiv/core-js";
import { getDisplaySubmit } from "@qgiv/core-donor";
import { useFormikContext } from "formik";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectRegistrationTotals } from "../../../redux/slices/registrationSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import Submit from "./Submit";

const ConnectedSubmit = ({ controlId }) => {
    const {
        ENUMS: { DefaultView, PaymentType },
    } = constants;

    const { values } = useFormikContext();
    const { Payment_Type } = values;
    const isCms = useSelector(selectIsCms);

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const {
        options: {
            ifNoTotalCompleteButtonLabel = "Complete Registration",
            ifTotalCompleteButtonLabel = "Complete Registration  •  %RegistrationGrandTotal%",
        },
    } = control;
    const { total } = useSelector(selectRegistrationTotals);
    const { currency } = useSelector(selectAllFormSettings);

    const registrationString = currencyString(total, currency);

    // Returns the markup for the submit button label based on whether or not
    // the registrationTotal is > 0
    const renderSubmitButtonLabel = () => {
        const beforeRegistrationString = ifTotalCompleteButtonLabel.split(
            "%RegistrationGrandTotal%",
        )[0];
        const afterRegistrationString = ifTotalCompleteButtonLabel.split(
            "%RegistrationGrandTotal%",
        )[1];
        // If the registration total is > 0, make the dollar value bold
        const submitButtonLabel =
            total > 0 ? (
                <>
                    {beforeRegistrationString}
                    <strong>{registrationString}</strong>
                    {afterRegistrationString}
                </>
            ) : (
                ifNoTotalCompleteButtonLabel
            );
        return submitButtonLabel;
    };

    // Display the submit button if the user is in CMS or the payment methods
    // other than Apple Pay are visible
    const displaySubmit = getDisplaySubmit({
        isCms,
        values,
    });

    // Do not display default processing state if the form is being
    // submitted after clicking the Apple Pay button
    const isApplePay = Payment_Type === PaymentType.APPLEPAY;

    const submitProps = {
        controlId,
        displaySubmit,
        isApplePay,
        isCms,
        renderSubmitButtonLabel,
    };
    return <Submit {...submitProps} />;
};

ConnectedSubmit.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedSubmit;
